import React from "react";

const Mic = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            fill={fill}
            d="M17.889 2c3.979 0 7.204 3.256 7.204 7.273v5.818c0 4.017-3.225 7.273-7.204 7.273-3.979 0-7.205-3.256-7.205-7.273V9.273C10.684 5.256 13.91 2 17.89 2ZM5 16.546h2.905c.699 4.934 4.903 8.727 9.984 8.727s9.285-3.793 9.984-8.727h2.905c-.665 6.067-5.437 10.885-11.448 11.556V34h-2.882v-5.898C10.438 27.432 5.664 22.613 5 16.546Z"
        />
    </svg>
);
export default Mic;
